// extracted by mini-css-extract-plugin
module.exports = {"confirmTitle":"confirm_confirmTitle__1etb8","confirmContent":"confirm_confirmContent__2GAev","confirmFooter":"confirm_confirmFooter__1qbGz"};